import { forwardRef } from "react";
import Button from "@mui/material/Button";
import PropTypes from "prop-types";

const PointieButton = forwardRef(({ color, variant, circular, children, ...rest }, ref) => {
  const muiVariant = variant === "gradient" ? "contained" : variant || "contained";

  const sx = { ...rest.sx };
  if (circular) sx.borderRadius = "50px";

  // Handle custom color mappings
  if (color === "white") {
    if (muiVariant === "outlined") {
      sx.color = "#fff";
      sx.borderColor = "rgba(255,255,255,0.75)";
      sx["&:hover"] = { borderColor: "#fff", backgroundColor: "rgba(255,255,255,0.1)" };
    } else {
      sx.bgcolor = "#fff";
      sx.color = "#344767";
      sx["&:hover"] = { bgcolor: "#f5f5f5" };
    }
    return (
      <Button ref={ref} variant={muiVariant} {...rest} sx={sx}>
        {children}
      </Button>
    );
  }

  if (color === "dark") {
    if (variant === "gradient") {
      sx.background = "linear-gradient(195deg, #42424a, #191919)";
      sx.color = "#fff";
      sx["&:hover"] = { background: "linear-gradient(195deg, #42424a, #191919)" };
    } else {
      sx.bgcolor = "#344767";
      sx.color = "#fff";
      sx["&:hover"] = { bgcolor: "#2c3e50" };
    }
    return (
      <Button ref={ref} variant={muiVariant} {...rest} sx={sx}>
        {children}
      </Button>
    );
  }

  const muiColor = !color || color === "default" ? "primary" : color;

  if (variant === "gradient") {
    const gradientMap = {
      info: "linear-gradient(195deg, #49a3f1, #1A73E8)",
      primary: "linear-gradient(195deg, #EC407A, #D81B60)",
      warning: "linear-gradient(195deg, #FFA726, #FB8C00)",
      success: "linear-gradient(195deg, #66BB6A, #43A047)",
      error: "linear-gradient(195deg, #EF5350, #E53935)",
    };
    sx.background = gradientMap[muiColor] || gradientMap.info;
    sx.color = "#fff";
    sx["&:hover"] = { boxShadow: "0px 14px 26px -12px rgba(0,0,0,0.4)" };
  }

  return (
    <Button ref={ref} variant={muiVariant} color={muiColor} {...rest} sx={sx}>
      {children}
    </Button>
  );
});

PointieButton.displayName = "PointieButton";
PointieButton.propTypes = {
  color: PropTypes.string,
  variant: PropTypes.string,
  circular: PropTypes.bool,
  children: PropTypes.node,
};
export default PointieButton;
